function alertJS(message) {
  const el = document.createElement('div');

  el.innerText = message;

  el.style.position = 'fixed';
  el.style.top = '20px';
  el.style.left = '50%';
  el.style.transform = 'translateX(-50%)';
  el.style.background = '#111';
  el.style.color = '#fff';
  el.style.padding = '12px 20px';
  el.style.borderRadius = '8px';
  el.style.zIndex = '9999';
  el.style.fontSize = '14px';
  el.style.opacity = '0';
  el.style.transition = 'all 0.3s ease';

  document.body.appendChild(el);

  setTimeout(() => {
    el.style.opacity = '1';
    el.style.transform = 'translateX(-50%) translateY(0)';
  }, 10);

  setTimeout(() => {
    el.style.opacity = '0';
    el.style.transform = 'translateX(-50%) translateY(-10px)';
    setTimeout(() => el.remove(), 300);
  }, 3000);
}

class ContactFormMinimal {
  static init() {
    if (this.initialized) return;
    this.initialized = true;

    this.bindOpen();
    this.bindClose();
    this.bindEsc();
  }

  static bindOpen() {
    document.querySelectorAll('a[href="#contact-form"]').forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();

        const form = document.querySelector('.js-contact-form-minimal');
        if (!form) return;

        form.classList.add('display');

        if (window.lenis) {
          window.lenis.stop();
        } else {
          document.body.style.overflow = "hidden";
        }

        setTimeout(() => {
          form.classList.add('active');
        }, 50);
      });
    });
  }

  static bindClose() {
    document.querySelectorAll('.js-close-contact-form-minimal').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        ContactFormMinimal.close();
      });
    });
  }

  static bindEsc() {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const form = document.querySelector('.js-contact-form-minimal');
        if (!form || !form.classList.contains('active')) return;

        ContactFormMinimal.close();
      }
    });
  }

  static close() {
    const form = document.querySelector('.js-contact-form-minimal');
    if (!form) return;

    form.classList.add('closing');

    setTimeout(() => {
      form.classList.remove('active', 'closing', 'display');

      if (window.lenis) {
        window.lenis.start();
      } else {
        document.body.style.overflow = "visible";
      }
    }, 300);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  ContactFormMinimal.init();
});